import { usePreferences } from '@trycourier/react-hooks';
import { ChannelClassification } from '@trycourier/react-hooks/typings/preferences/types';
import React from 'react';
import ChannelPreference from './ChannelPreference';
import { useFirebase } from '../../../../services/firebase';
import { LOADING_STATE } from '../../../../util/loading';
import AlertBox from '../../../common/AlertBox';
import { useIonToast } from '@ionic/react';
import { warning } from 'ionicons/icons';

interface ChannelPreferencesProps {
  templateId: string;
  channels: ChannelClassification[];
  topicDisabled: boolean;
  channelPreferences: {
    email: boolean;
    sms: boolean;
    push: boolean;
  };
  updateUserChannelPreference: (
    userId: string,
    templateId: string,
    channel: 'email' | 'sms' | 'push',
    enabled: boolean
  ) => Promise<void>;
  loadingState: LOADING_STATE;
}

const ChannelPreferences: React.FC<ChannelPreferencesProps> = ({
  templateId,
  channels,
  topicDisabled,
  channelPreferences,
  updateUserChannelPreference,
  loadingState,
}) => {
  const { currentUser, app } = useFirebase();
  const preferences = usePreferences();
  const [present] = useIonToast();

  if (!preferences || loadingState === LOADING_STATE.LOADING) {
    return null;
  }

  if (loadingState === LOADING_STATE.ERROR) {
    return (
      <div style={{ paddingLeft: '32px' }}>
        <AlertBox
          type="error"
          text="Error loading notification channel preferences. Please try again later."
        />
      </div>
    );
  }

  const channelArray = Object.keys(channelPreferences).map((key) => ({
    id: key,
    enabled: channelPreferences[key],
  }));

  return (
    <div style={{ paddingLeft: '32px' }}>
      {channelArray.map((channel) => (
        <ChannelPreference
          templateId={templateId}
          key={channel.id}
          topicDisabled={topicDisabled}
          toggled={channel.enabled && !topicDisabled}
          channel={channel.id as ChannelClassification}
          onChange={(toggled) => {
            try {
              updateUserChannelPreference(
                currentUser!.uid,
                templateId,
                channel.id as any,
                toggled
              );
            } catch (e) {
              console.error('Error updating user channel preferences:', e);
              present({
                message:
                  'Error updating notification preferences. Please try again later.',
                duration: 3000,
                color: 'danger',
                icon: warning,
              });
            }

            // TODO: uncomment when we can save this in Courier
            // const newRoutingPreferences =
            //   filteredPreference?.routingPreferences ?? [];
            // if (toggled) {
            //   newRoutingPreferences.push(option);
            // } else {
            //   const index = newRoutingPreferences.indexOf(option);
            //   if (index > -1) {
            //     newRoutingPreferences.splice(index, 1);
            //   }
            // }
            // preferences.updateRecipientPreferences({
            //   templateId: templateId,
            //   routingPreferences: newRoutingPreferences,
            //   hasCustomRouting: true,
            //   status: filteredPreference?.status,
            //   tenantId: currentUser!.uid,
            // });
            // setRouting(newRoutingPreferences);
          }}
        />
      ))}
    </div>
  );
};

export default ChannelPreferences;
